import memoize from 'lru-memoize';

import {getInstanceTimesInRange} from './recurrenceHelpers';

// Since rrule.between is one of the major bottlenecks in event rendering speed,
// we memoize the instance time computations.
export const getInstanceTimesInRangeMemoized = memoize(2000)(
  (
    recurrenceString: string,
    startsAt: number,
    optionalTimezone: string | null | undefined,
    rangeStartsAt: number,
    rangeEndsAt: number,
  ) => getInstanceTimesInRange(recurrenceString, startsAt, optionalTimezone, rangeStartsAt, rangeEndsAt),
);

export async function clearCalendarRecurrencesStorage() {
  // no-op on web
}
